class EditorPreviewBanner extends HTMLElement {
  connectedCallback() {
    if (!window.Shopify || !window.Shopify.designMode) return;

    this.trigger = this.querySelector('[data-trigger]');
    this.panel = this.querySelector('[data-panel]');
    this.dismissButton = this.querySelector('[data-dismiss]');
    this.linkButtons = this.querySelectorAll('[data-href]');

    if (!this.trigger || !this.panel) return;

    // Toggle panel
    this.onTriggerClick = () => {
      this.panel.hidden = !this.panel.hidden;
    };
    this.trigger.addEventListener('click', this.onTriggerClick);

    // Dismiss (hide panel, NOT component)
    if (this.dismissButton) {
      this.onDismissClick = () => {
        this.panel.hidden = true;
        this.dismissed = true; // optional flag
      };

      this.dismissButton.addEventListener('click', this.onDismissClick);
    }

    // Open links
    if (this.linkButtons.length) {
      this.onLinkClick = (event) => {
        const url = event.currentTarget.getAttribute('data-href');
        if (!url) return;

        window.open(url, '_blank', 'noopener,noreferrer');
      };

      this.linkButtons.forEach((btn) => {
        btn.addEventListener('click', this.onLinkClick);
      });
    }

    // Outside click closes panel
    this.onDocumentClick = (event) => {
      if (!this.contains(event.target)) {
        this.panel.hidden = true;
      }
    };

    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    if (this.trigger && this.onTriggerClick) {
      this.trigger.removeEventListener('click', this.onTriggerClick);
    }

    if (this.dismissButton && this.onDismissClick) {
      this.dismissButton.removeEventListener('click', this.onDismissClick);
    }

    if (this.linkButtons && this.onLinkClick) {
      this.linkButtons.forEach((btn) => {
        btn.removeEventListener('click', this.onLinkClick);
      });
    }

    if (this.onDocumentClick) {
      document.removeEventListener('click', this.onDocumentClick);
    }
  }
} 

if (!customElements.get('editor-preview-banner')) {
  customElements.define('editor-preview-banner', EditorPreviewBanner);
}